import { instrumentSentryForUi } from 'apps/sigma2-ui/src/instrument-sentry-for-ui';
import * as Sentry from '@sentry/react';
instrumentSentryForUi();
import React from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';
import { App } from 'apps/sigma2-ui/src/components/App';
import './reset.css';
import './style.css';
import { uiAppLogger } from 'apps/sigma2-ui/src/lib/logging';
import { S2Theme } from 'apps/sigma2-ui/src/theme';
import { installMuiXLicense } from 'apps/sigma2-ui/src/mui-x-license';

installMuiXLicense();

async function renderApp() {
  uiAppLogger.info('Rendering app');

  const ProfiledApp = Sentry.withProfiler(App);
  const app = (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={S2Theme}>
        <ProfiledApp />
      </ThemeProvider>
    </StyledEngineProvider>
  );

  const rootNode = document.getElementById('root');

  if (!rootNode) {
    throw new Error('Root node not found');
  }

  createRoot(rootNode).render(app);
}

// First render
renderApp();
